import React, { Component } from 'react';
import { Typography, Grid, Table, TableHead, TableCell, TableRow, TableBody, Chip } from '@material-ui/core';
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import { Button, FormControl, Card } from 'react-bootstrap';
import { PostData, GetData, DeleteData, PutData } from '../../api/service';
import Snack from '../Snackbar/Snack';
import FileUpload from '../AddNew/FileUpload';
import Edit from '@material-ui/icons/Edit'
import Delete from '@material-ui/icons/Delete'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css


class ResourceLink extends Component {
    state = {
        id: '',
        edit: false,
        type: '',
        links: [],
        linkText: '',
        linkPath: '',
        data: [],
        isDataLoaded: false,
        dept_code: this.props.dept_code,
        message: '',
        open: false,
        loadFile: true
    }

    handleChange = (name, value) => {
        this.setState({
            [name]: value
        })
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    __getDeptData = () => {
        GetData(`/getlinks`)
            .then((resp) => {
                //console.log(resp)
                this.setState({
                    data: resp,
                    isDataLoaded: true
                })
            })
    }

    componentDidMount() {
        this.__getDeptData();

    }


    onSubmit = (e) => {
        e.preventDefault();

        let d = {
            id: this.state.id,
            type: this.state.type,
            links: this.state.links
        }

        if (this.state.edit) {
            PutData(`/admin/${this.state.id}/editlinks`, d)
                .then((resp) => {
                    //console.log(resp)
                    this.setState({
                        message: resp,
                        open: true
                    }, () => this.__getDeptData())
                    this.cancelEdit();
                })
        } else {
            PostData(`/admin/addlinks`, d)
                .then((resp) => {
                    //console.log(resp)
                    this.setState({
                        message: resp,
                        open: true
                    }, () => this.__getDeptData())
                    this.cancelEdit();
                })
        }


    }

    onDeleteClick = (el) => {
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: this.onDeleteConfirm.bind(this, el.id)
                },
                {
                    label: 'No'
                }
            ]
        })
    }

    onDeleteConfirm = (id) => {
        DeleteData(`/${this.props.apikey}/${id}/deletelinks`)
            .then((resp) => {
                this.setState({
                    message: resp,
                    open: true
                }, () => this.__getDeptData())
            })
    }

    onEditClick = (el) => {
        this.setState({
            ...el,
            edit: true,
            loadFile: false
        }, () => {
            this.setState({
                loadFile: true
            })
        })
    }

    cancelEdit = () => {
        this.setState({
            id: '',
            type: '',
            
            links: [],
            linkText: '',
            linkPath: '',
            edit: false,
            loadFile: false
        }, () => {
            this.setState({
                loadFile: true
            })
        })
    }

    addMember = () => {
        let links = this.state.links;

        if (this.state.linkText != '' && this.state.linkPath != '') {
            let d = {
                linkText: this.state.linkText,
                linkPath: this.state.linkPath
            }
            links.push(d)
            this.setState({
                links: links,
                linkText: '',
                linkPath: ''
            })
        }
    }

    onDelete = (index) => {
        let links = this.state.links;

        links.splice(index,1);
        this.setState({
            links: links
        })
    }


    render() {
        return (
            <div>

                {this.state.open ? (
                    <Snack
                        open={this.state.open}
                        message={this.state.message}
                        handleClose={() => {
                            this.setState({
                                open: false,
                                message: ''
                            })
                        }}
                    />
                ) : null}

                <form onSubmit={this.onSubmit}>
                    <Typography
                        variant="h6"
                        gutterBottom
                    >
                        Resource Links
                    </Typography>

                    


                    <Card>

                        <Card.Body>


                            <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <label>Type</label>

                                    
                                    <FormControl
                                        as="select"
                                        name="type"
                                        required
                                        onChange={this.onChange}
                                        value={this.state.type}
                                    >
                                        <option value="">Select</option>
                                        <option value="FEEDBACK_LINK">FEEDBACKS</option>
                                        {/* <option value="RESOURCE_LINK">RESOURCES</option> */}
                                        
                                    </FormControl>
                                    
                                </Grid>


                                

                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <label>Link Text</label>
                                    <FormControl
                                        as="input"
                                        name="linkText"
                                        onChange={this.onChange}
                                        value={this.state.linkText}
                                        placeholder="linkText"
                                    />
                                    <label>Path</label>
                                    <FormControl
                                        as="input"
                                        name="linkPath"
                                        onChange={this.onChange}
                                        value={this.state.linkPath}
                                        placeholder="linkPath"
                                    />
                                    <br />

                                    <Button
                                        size="sm"
                                        onClick={this.addMember}
                                    >
                                        Add
                                    </Button>
                                </Grid>

                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <label>List of Links</label>
                                    <br />
                                    {this.state.links.map((el, index) =>
                                        <Chip label={`${el.linkText}: ${el.linkPath}`}
                                            key={index}
                                            onDelete={this.onDelete.bind(this, index)}
                                            className="m-1" />)}
                                </Grid>







                            </Grid>



                            {this.state.edit ? (
                                <div align="right">
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        type="submit"
                                    >
                                        Update
                                    </Button>
                                    &nbsp;
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        type="button"
                                        onClick={this.cancelEdit}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            ) : (<div align="right">
                                <Button
                                    size="sm"
                                    variant="info"
                                    type="submit"
                                >
                                    Final Submit
                    </Button>
                            </div>)}

                        </Card.Body>

                    </Card>

                    <br />


                    <Card>

                        <Card.Body>
                            {this.state.isDataLoaded ? (
                                <div>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>#</TableCell>
                                                <TableCell width="30%">Type</TableCell>
                                                <TableCell wodth='20%'>Links</TableCell>

                                               
                                                <TableCell>Edit</TableCell>
                                                <TableCell>Delete</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.data.map((el, index) =>

                                                <TableRow key={index}>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>{el.type}
                                                        
                                                    </TableCell>
                                                   
                                                    <TableCell>
                                                        {Array.isArray(el.links) && el.links.map((el1, index1) =>
                                                            <Chip
                                                                key={index1}
                                                                label={`${el1.linkText} : ${el1.linkPath}`}
                                                            />
                                                        )}
                                                    </TableCell>
                                                   
                                                    <TableCell><Edit onClick={this.onEditClick.bind(this, el)} /></TableCell>
                                                    <TableCell><Delete onClick={this.onDeleteClick.bind(this, el)} /></TableCell>
                                                </TableRow>

                                            )}
                                        </TableBody>
                                    </Table>
                                </div>
                            ) : <Typography>
                                    Loading . . .
                            </Typography>}
                        </Card.Body>

                    </Card>

                </form>
            </div>
        );
    }
}


export default ResourceLink;